import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { msg } from '@lingui/core/macro';
import {
  currencyField,
  currencyQuantityField,
  beaCodeField,
} from './common/expenditureFields';

export const corporate315InvestmentsMetadata = {
  displayName: msg({
    message: 'Corporate investments',
    context: 'Activity data schema name for corporate investments',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    asset_value: {
      displayName: msg({
        message: 'Asset value',
        context: 'The sum of total company equity and debt',
      }),
      externalDescription: msg({
        message: 'The sum of total company equity and debt',
        context: 'Asset value',
      }),
    },
    bea_code: beaCodeField,
    currency: currencyField,
    currency_quantity: currencyQuantityField,
    outstanding_amount: {
      displayName: msg({
        message: 'Outstanding amount',
        context:
          'The outstanding value of debt owed to the lender, equity held in a private company, or market price times number of shares for listed equity',
      }),
      externalDescription: msg({
        message:
          'The outstanding value of debt owed to the lender, equity held in a private company, or market price times number of shares for listed equity',
        context: 'Outstanding amount',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
